const C = {
  name: "Slovakia",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3999 9.19995H18.2001V11.2H13.3999V15.3128C14.5838 15.5837 15.6074 16.3238 16.2399 17.3335C16.6968 17.125 17.2073 17 17.8 17C20.0523 17 21.8 18.7477 21.8 21H19.8C19.8 19.8522 18.9477 19 17.8 19C17.3034 19 16.9222 19.1665 16.4402 19.5682L15.2372 20.5706L14.8338 19.0576C14.5498 17.9928 13.5443 17.2 12.4 17.2C11.2557 17.2 10.2502 17.9928 9.96624 19.0576L9.56276 20.5706L8.35982 19.5682C7.87776 19.1665 7.4966 19 7 19C5.85228 19 5 19.8522 5 21H3C3 18.7477 4.74772 17 7 17C7.59265 17 8.10321 17.125 8.56013 17.3335C9.19257 16.3238 10.2161 15.5837 11.3999 15.3129V11.2H6.6001V9.19995H11.3999V7.59998H7.7998V5.59998H11.3999V2H13.3999V5.59998H16.9998V7.59998H13.3999V9.19995Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Slovakia
};
